import { Component } from 'react';
import { connect } from 'react-redux';
import { RouteService } from '../../util/services/route';
import { factoryActions } from '../../util/store/factory/reducer';
import { IRoute } from '../../util/varibles/interface';
import { SOCKET_FUNC, SOCKET_NAME } from "../../web-socket/constants";
import WSService, { IResultSocket } from "../../web-socket/web-socket-service";
import RowResize from "./_components/RowResize";
import BiologyBrowser from './BiologyBrowser';
import Plan from './Plan';
import PopupOperation from "./Popup/EditOp";
import { planOpActions } from "./reducer";
import styles from './style.module.scss';

interface IProps {

    initialData: typeof planOpActions.initialRequest

    getVessels(payload: any): void

    getSites(payload: any): void

    saveRoutes(rs: IRoute[]): void

    getFactories: typeof factoryActions.gets

    updateOpByWs: typeof planOpActions.updateOpByWs

    updateOpsByWs(payload: { data: any, mode: 'update' | 'update-without-level' | 'remove' | 'none' }): void

    updateAvailableTime(payload: any): void

    deleteAvailableTime(payload: any): void

    updateUnitsAndHarvests(payload: { units: any, harvests: any }): void

    closePopup: typeof planOpActions.closePopup,

    updateServiceRequests: typeof planOpActions.updateServiceRequests
}

class PlanOperationPage extends Component<IProps> {
    groupIds = [];
    abort: AbortController = new AbortController();

    componentDidMount() {
        document.body.style.overflow = 'hidden';
        this.abort = new AbortController();
        const processMessage = (value: IResultSocket) => {
            const data = value.message

            switch (value.function) {
                case SOCKET_FUNC.OPERATION_CONFIRMED: {
                    this.props.updateOpsByWs({ data, mode: 'update' })
                    break;
                }
                case SOCKET_FUNC.OPERATION_DELETED:
                case SOCKET_FUNC.OPERATION_RESET: {
                    this.props.updateOpsByWs({ data, mode: 'remove' })
                    break;
                }
                case SOCKET_FUNC.AVAILABLE_TIME_CHANGE: {
                    this.props.updateAvailableTime(data)
                    break;
                }
                case SOCKET_FUNC.AVAILABLE_TIME_DELETED: {
                    this.props.deleteAvailableTime(data)
                    break;
                }
                case SOCKET_FUNC.HARVEST_CHANGE: {
                    this.props.getSites({ abort: this.abort });
                    break;
                }
                case SOCKET_FUNC.OPERATION_STATE_CHANGE:
                case SOCKET_FUNC.OPERATION_STATUS_CHANGE: {
                    this.props.updateOpsByWs({ data: data || [], mode: 'none' })
                    break;
                }
                case SOCKET_FUNC.ONGOING_UPDATE: {
                    this.props.updateOpsByWs({ data: Array.isArray(data.operations) ? data.operations || [] : [], mode: 'none' })
                    break;
                }
                case SOCKET_FUNC.OPERATION_EDITED: {
                    this.props.updateOpByWs({ data })
                    break;
                }
                case SOCKET_FUNC.UPDATE_UNIT_HARVEST: {
                    const { units = [], harvests = [] } = value.message;
                    this.props.updateUnitsAndHarvests({ units, harvests });
                    break;
                }
                case SOCKET_FUNC.SERVICE_REQEUEST_CHANGE: {
                    this.props.updateServiceRequests(value.message);
                    break;
                }
                default:
                    return;
            }
        }
        this.props.getVessels({
            abort: this.abort,
            callback: (vessels: any) => {
                if (this.abort.signal.aborted) return;
                if (vessels.length > 0) {
                    this.groupIds = vessels.map((item: any) => item.vessel.id)
                    new WSService({
                        groups: this.groupIds,
                        listener: {
                            lev: SOCKET_NAME.PAGE,
                            func: (value: IResultSocket) => processMessage(value)
                        }
                    });
                }
            }
        });
        this.props.initialData();
        this.props.getFactories();
        this.props.getSites({ abort: this.abort });
        RouteService.gets()
            .then(rs => this.props.saveRoutes(rs))
            .catch(error => console.log('Get routes failed:', error))
    }

    componentWillUnmount(): void {
        document.body.style.overflow = '';
        this.props.closePopup();
        WSService.close(SOCKET_NAME.PAGE, this.groupIds);

        if (this.abort)
            this.abort.abort()
    }

    render() {
        return <div className='m-header bgPage'>
            <div id='container-plan' className={styles['plan-operation']}>
                <BiologyBrowser />
                <RowResize />
                <Plan />
            </div>
            <PopupOperation />
        </div>;
    }
}

export default connect(null, {
    initialData: planOpActions.initialRequest,
    getVessels: planOpActions.getVesselsRequest,
    getSites: planOpActions.getSitesRequest,
    saveRoutes: planOpActions.saveRoutes,
    getFactories: factoryActions.gets,
    updateOpByWs: planOpActions.updateOpByWs,
    updateOpsByWs: planOpActions.updateOpsByWs,
    updateAvailableTime: planOpActions.updateAvailableTime,
    deleteAvailableTime: planOpActions.deleteAvailableTime,
    updateUnitsAndHarvests: planOpActions.updateUnitsAndHarvests,
    closePopup: planOpActions.closePopup,
    updateServiceRequests: planOpActions.updateServiceRequests
})(PlanOperationPage)

